import React from 'react';
import { DonutChart } from '../components';

class CardDevices extends React.Component{

    render(){
        return (
            <div className="card h-100 shadow-sm">
                <div className="card-body p-xl-3 p-2 d-flex flex-column">
                    <h4 className="font-weight-light">
                        <div className="float-right dropdown show"><button data-toggle="dropdown" className="btn btn-link p-0 dropdown-toggle"><i className="lnr lnr-cog"></i></button>
                            <div className="dropdown-menu dropdown-menu-right">
                                <button className="dropdown-item">Action</button>
                                <button className="dropdown-item">Another action</button>
                            </div>
                        </div>
                        Devices
                    </h4>
                    <div className="my-auto p-1">
                        <DonutChart />
                    </div>
                    <table className="table table-hover table-sm d-xl-table d-md-none d-sm-table mb-0 text-uppercase small">
                        <tbody>
                        <tr>
                            <td>Desktop</td>
                            <td>52%</td>
                            <td><h5 className="mb-0 text-right"><span className="badge badge-pill bg-light border">&nbsp;</span></h5></td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td>40%</td>
                            <td><h5 className="mb-0 text-right"><span className="badge badge-pill bg-primary">&nbsp;</span></h5></td>
                        </tr>
                        <tr>
                            <td>Tablet</td>
                            <td>15%</td>
                            <td><h5 className="mb-0 text-right"><span className="badge badge-pill bg-dark">&nbsp;</span></h5></td>
                        </tr>
                        <tr>
                            <td>Unknown</td>
                            <td>5%</td>
                            <td><h5 className="mb-0 text-right"><span className="badge badge-pill bg-secondary">&nbsp;</span></h5></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default CardDevices;